
<template>
    <div class="cutscenes-mask">
        <div class="cutscenes">
            <div class="title-box title-box-m">
                <div
                    class="title title-m"
                    v-for="i in array"
                    v-bind:key="i"
                >
                    <p
                        class="item item-m"
                    >
                        <!-- HOT -->
                        <img v-bind:src="ImgHot" alt="">
                    </p>
                </div>
            </div>
            <div class="title-box">
                <div
                    class="title title-s"
                    v-for="i in array"
                    v-bind:key="i"
                >
                    <p class="item item-s">
                        <!-- SAUCE -->
                        <img v-bind:src="ImgSauce" alt="">

                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import ImgHot from '@/assets/images/hot.png';
import ImgSauce from '@/assets/images/sauce.png';
const array = [1, 2, 3, 4, 5, ];
const props = defineProps({
  isShow: {
    type: Boolean,
    default: () => false,
  },
});

</script>

<style lang="scss">
@import '~@/scss/foundation/config';
$bg: #008d5b;
$text1: #ff0000;
$text2: #fdfefe;
$text-delay: 500ms;

@mixin bounceration-down($name, $start, $end, $pos) {
    @keyframes bounceration-down-#{$name} {
        0% {
            transform: translateY(-130%);
        }
        #{$start}% {
            transform: translateY($pos);
            // opacity: 1;
        }
        #{$end}% {
            transform: translateY($pos);
            // opacity: 1;
        }
        100% {
            transform: translateY(-130%);
            // opacity: 0;
        }
    }
}
@mixin bounceration-up($name, $start, $end, $pos) {
    @keyframes bounceration-up-#{$name} {
        0% {
            transform: translateY(100%);
        }
        #{$start}% {
            transform: translateY($pos);
            // opacity: 1;
        }
        #{$end}% {
            transform: translateY($pos);
            // opacity: 1;
        }
        100% {
            transform: translateY(100%);
            // opacity: 0;
        }
    }
}
@include bounceration-down(1, 40, 90, 0%);
@include bounceration-down(2, 50, 85, -20%);
@include bounceration-down(3, 60, 80, -25%);
@include bounceration-down(4, 70, 75, -45%);
@include bounceration-down(5, 80, 85, -85%);
// @include bounceration-down(5, 30, 50, 100%);
@include bounceration-up(1, 40, 90, 0%);
@include bounceration-up(2, 50, 85, 20%);
@include bounceration-up(3, 60, 80, 35%);
@include bounceration-up(4, 70, 75, 48%);
@include bounceration-up(5, 75, 85, 75%);
@keyframes expand-y-in {
    0% {
        height: 0;
        opacity: .1;
    }
    20% {
        height: 10%;
        opacity: .8;
    }
    30% {
        height: 100%;
        opacity: 1;
    }

    90% {
        height: 100%;
        opacity: 1;
    }
    100% {
        height: 0;
        opacity: .1;
    }
}

.cutscenes {
    position: absolute;
    width: 100%;
    height: 100%;
    background: $bg;
    top: 50%;
    transform: translateY(-50%);
    animation: expand-y-in 1900ms ease;
    height: 0;
    opacity: 0;
    .title-box {
        position: relative;
        overflow: hidden;
        height: 50%;
    }
    .title {
        position: relative;
        width: 100%;
        height: 25%;
        overflow: hidden;
    }
    .item {
        // background: $bg;
        font-weight: bold;
        padding: 1% 0;
        line-height: .7;
        position: absolute;
        width: 100%;
        animation-delay: $text-delay!important;

        img {
            width: 70%;
        }
    }

    .item-m {
        font-size: 10.3rem;
        color: $text1;
        bottom: 0;
        transform: translateY(100%);
    }
    .title {
        margin: 3px 0;
    }
    .title.title-m:nth-of-type(1) {
        height: 20%;
        & > .item-m {
            animation: bounceration-up-5 1200ms ease-out;
            // animation-delay: .2s;
        }
    }
    .title.title-m:nth-of-type(2) {
        height: 16%;
        & > .item-m {
            animation: bounceration-up-4 1200ms ease-out;
            // animation-delay: .2s;
        }
    }
    .title.title-m:nth-of-type(3) {
        height: 18%;
        .item-m {
            animation: bounceration-up-3 1200ms ease-out;
            // animation-delay: .2s;
        }
    }
    .title.title-m:nth-of-type(4) {
        height: 20%;
        .item-m {
            animation: bounceration-up-2 1200ms ease-out;
            // animation-delay: .2s;
        }
    }
    .title.title-m:nth-of-type(5) {
        height: 22%;
        .item-m {
            // transform: translateY(70%);
            animation: bounceration-up-1 1200ms ease-out;
            // animation-delay: .2s;
        }
    }

    .item-s {
        font-size: 6rem;
        color: $text2;
        transform: translateY(-130%);
    }
    .title.title-s:nth-of-type(1) {
        // animation: bounceration-down-5 1200ms ease-out;
        height: 28%;
        & > .item-s {
            // transform: translateY(-80%);
            animation: bounceration-down-1 1200ms ease-out;
        }
    }
    .title.title-s:nth-of-type(2) {
        height: 17%;
        & > .item-s {
            animation: bounceration-down-2 1200ms ease-out;
            // animation-delay: .2s;
        }
    }
    .title.title-s:nth-of-type(3) {
        height: 13%;
        .item-s {
            animation: bounceration-down-3 1200ms ease-out;
            // animation-delay: .2s;
        }
    }
    .title.title-s:nth-of-type(4) {
        height: 14%;
        .item-s {
            animation: bounceration-down-4 1200ms ease-out;
            // animation-delay: .2s;
        }
    }
    .title.title-s:nth-of-type(5) {
        height: 10%;
        .item-s {
            animation: bounceration-down-5 1200ms ease-out;
            // animation-delay: .2s;
        }
    }
    .title.title-s {
        // position: absolute;
        // transform: translateY(-100%);
        // top: 0;
    }
}

  .cutscenes-mask {
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    text-align: center;
    transition: all 1.618s;
    &.loading {
     display: flex;

    }

    &.loaded {
      opacity: 0;
      visibility: hidden;
    }

    .box {
      display: inline-block;
      vertical-align: middle;

      .logo-img {
        width: 100px;
        display: inline-block;
        animation: rotate-animation 3s linear infinite;

      }

      .progress {
        margin-top: 1rem;
        font-size: 2rem;
        // color: #C13BEB;
      }
      .link > a{
        font-size: 1.4rem;
        color: #db7df8;
      }
    }

  }

</style>
